import { Component } from "react"
import PropTypes from "prop-types"
import keys from "lodash/keys"
import sum from "lodash/sum"
import values from "lodash/values"

export default class ErrorBreakdownChart extends Component {
  constructor(props) {
    super(props)
  }

  async componentDidMount() {
    const Highcharts = await import("highcharts")
    Highcharts.setOptions(window.globalHighchartsOptions)

    Highcharts.setOptions({
      colors: [
        "#09f",
        "#e43",
        "#fc0",
        "#7b1",
        "#f90",
        "#649",
        "#333",
        "#666",
        "#999",
      ],
    })
    this.chart = new Highcharts.Chart({
      chart: {
        animation: false,
        renderTo: this.chartContainer,
        type: "bar",
        height: 250,
        spacing: [10, 0, 10, 0],
      },
      title: {
        text: "",
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        title: {
          enabled: false,
        },
        categories: keys(this.props.data),
        labels: {
          style: {
            color: "#999",
            fontSize: "14",
            fontWeight: "700",
          },
        },
        tickmarkPlacement: "on",
        gridLineWidth: 4,
        gridLineColor: "#f5f5f5",
        lineWidth: 0,
        tickInterval: 1,
        tickWidth: 0,
      },
      yAxis: {
        title: {
          enabled: false,
        },
        labels: {
          enabled: false,
        },
        gridLineWidth: 0,
      },
      plotOptions: {
        bar: {
          groupPadding: 0,
          pointPadding: 0,
          shadow: false,
        },
        series: {
          animation: false,
          colorByPoint: true,
        },
      },
      tooltip: {
        enabled: false,
      },
      series: [
        {
          name: "Errors",
          data: this.convertDataToSeries(),
          dataLabels: {
            enabled: true,
            format: "{y}%",
            style: {
              color: "#333",
              fontSize: "14",
              fontWeight: "700",
              textOutline: "3px contrast",
            },
          },
          pointWidth: 12,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      ],
    })
  }

  componentWillUnmount() {
    this.chart.destroy()
  }

  convertDataToSeries() {
    let total = sum(values(this.props.data))
    let data = []
    let perc = 0

    for (let prop in this.props.data) {
      perc = this.props.data[prop]
      perc = (perc * 100) / total // percentage
      perc = Math.round(perc * 100) / 100 // precision
      data.push([prop, perc])
    }

    return data
  }

  render() {
    return (
      <div
        className="error-breakdown-chart-container"
        ref={c => (this.chartContainer = c)}
      />
    )
  }
}

ErrorBreakdownChart.propTypes = {
  data: PropTypes.object.isRequired,
}
